module.exports = __webpack_public_path__ + "media/images/app/trust/iconFive-18ab02f006a8af8b586222f1e113a155.webp";